import Main3TCWrapper from "../../components/live3/tc/Main3TCWrapper";
import { config3 } from "../../constant/initDrawing";


const config = {
    ...config3,
    type: "mt",
    hlBG: "#E5C5FF",
    row_0: "#BD65BD",
}

const Live3MTPage = () => {
    return <Main3TCWrapper config={config} />
}

export default Live3MTPage;